<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      :row-class-name="tableRowClassName"
      tableCardTitle="LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:status="{ tableRow }">
        <el-popconfirm
          v-if="tableRow.row.status === 1"
          title="Change status to inactive ?"
          confirm-button-text="Confirm"
          cancel-button-text="Cancel"
          @confirm="handleConfirmBtn(tableRow.row)"
        >
          <a href="javascript:void (0)" slot="reference" style="color: #54afe1">
            {{ tableRow.row.statusStr }}
          </a>
        </el-popconfirm>
        <span v-else>{{ tableRow.row.statusStr }}</span>
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0); "
          class="icon-pencil1"
          style="color: #3a3f63"
          @click="handleEditItem(tableRow.row)"
        />
      </template>
      <template v-slot:dueDate="{ tableRow }">
        <span v-if="tableRow.row.status === 2" style="color: red">
          {{ tableRow.row.dueDate }}
        </span>
        <span v-else style="color: #54afe1">{{ tableRow.row.dueDate }}</span>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="446px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-card shadow="never">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          labelPosition="top"
          label-suffix=":"
        >
          <el-form-item label="Parent Company #" prop="companyId">
            <el-select
              v-model="form.companyId"
              style="width: 100%"
              filterable
              remote
              :remote-method="name => remoteMethod(name)"
              :loading="loading"
              placeholder="search"
              @change="handleSelectChange"
            >
              <el-option
                v-for="item in parentCompanyList"
                :value="item.id"
                :label="item.name"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Parent Company Name">{{ name }}</el-form-item>
          <el-form-item
            label="Parent Company Customer Type"
            prop="parentCustomerType"
          >
            <el-select v-model="form.parentCustomerType" style="width: 100%">
              <el-option
                v-for="item in selectList"
                :value="item.id"
                :label="item.name"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Group Limit (USD)" prop="groupLimit">
            <el-input v-model="formattedGroupLimit"
                      @input="handleGroupLimitInput"
                      @blur="handleGroupLimitBlur"/>
          </el-form-item>
          <el-form-item label="Group Due Date" prop="dueDate">
            <el-date-picker
              valueFormat="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%"
              v-model="form.dueDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Group Type" prop="groupType">
            <el-select v-model="form.groupType" style="width: 100%">
              <el-option :value="1" label="Legal" />
              <el-option :value="2" label="Business" />
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  add,
  getTableData,
  screeningParentCompany,
  setInvalid,
  update,
} from './api'
import dayjs from 'dayjs'

export default {
  data() {
    const searchModel = [
      {
        label: 'Parent Company #',
        type: 'input',
        key: 'parentCompanyCode',
      },
      {
        label: 'Parent Company Name',
        type: 'input',
        key: 'parentCompanyName',
      },
    ]
    const tableModel = [
      {
        label: 'Parent Company #',
        prop: 'parentCompany',
      },
      {
        label: 'Parent Company Name',
        prop: 'parentCompanyName',
      },
      {
        label: 'Group Limit',
        prop: 'groupLimit',
      },
      {
        label: 'Due Date',
        slotName: 'dueDate',
      },
      {
        label: 'Group Type',
        prop: 'groupTypeStr',
      },
      {
        label: 'Status',
        slotName: 'status',
      },
      {
        label: 'Action',
        width: 100,
        slotName: 'action',
      },
    ]
    this.formId = ''
    return {
      today: '',
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        companyId: '',
        groupLimit: '',
        dueDate: '',
        groupType: '',
        parentCustomerType: '',
      },
      formattedGroupLimit: '',
      rules: {
        companyId: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        groupLimit: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        dueDate: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        // groupType: [
        //   { required: true, message: 'Can not be empty!', trigger: 'change' },
        // ],
        parentCustomerType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      isTableLoading: true,
      parentCompanyList: [],
      name: '',
      loading: false,
      selectList: [
        {
          id: 1,
          name: 'Trade',
        },
        {
          id: 2,
          name: 'Eaas',
        },
        {
          id: 3,
          name: 'Saas',
        },
      ],
    }
  },
  mounted() {
    this.initTable()
    this.today = dayjs().format('YYYY-MM-DD')
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.status === 2) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    },
    // 处理输入事件，实时格式化显示
    handleGroupLimitInput(value) {
      // 移除所有非数字字符和多余的点号，但保留一个小数点
      let numericValue = value.replace(/[^0-9.]/g, '')

      // 限制只能有一个小数点
      const parts = numericValue.split('.')
      if (parts.length > 2) {
        numericValue = parts[0] + (parts[1] ? '.' + parts[1] : '')
      }

      // 更新实际存储值
      this.form.groupLimit = numericValue

      // 更新格式化显示值
      if (numericValue) {
        this.formattedGroupLimit = this.$utils.setSeperatenum(numericValue)
      } else {
        this.formattedGroupLimit = ''
      }
    },

    // 失焦时处理
    handleGroupLimitBlur() {
      if (this.form.groupLimit) {
        // 确保失焦时格式正确
        this.formattedGroupLimit = this.$utils.setSeperatenum(this.form.groupLimit)
      }
    },
    greaterThanToday(date) {
      if (new Date(date).valueOf() < new Date(this.today).valueOf()) {
        return true
      }
      return false
    },
    async handleConfirmBtn({ id, companyId }) {
      try {
        await setInvalid(id, companyId)
        this.$message.success('success')
        this.initTable()
      } catch (e) {
        console.log(e)
      }
    },
    handleSelectChange(value) {
      const res = this.parentCompanyList.filter(item => item.id === value)
      if (res) {
        this.name = res[0].name
      }
    },
    async remoteMethod(name) {
      if (name !== '') {
        this.loading = true
        this.parentCompanyList = await screeningParentCompany(name)
        this.loading = false
      } else {
        this.parentCompanyList = []
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.tableData.map(item => {
          item.groupLimit = this.$utils.formatAmount(item.groupLimit)
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async handleEditItem(row) {
      try {
        this.visible = true
        this.$nextTick(async () => {
          Object.keys(this.form).forEach(key => {
            this.form[key] = row[key]
          })
          this.formId = row.id
          await this.remoteMethod(row.parentCompany)
          this.name = row.parentCompanyName

          // 初始化格式化显示值
          if (row.groupLimit) {
            // 移除已有的千分位符号
            const cleanValue = row.groupLimit.toString().replace(/,/g, '')
            this.form.groupLimit = cleanValue
            this.formattedGroupLimit = this.$utils.setSeperatenum(cleanValue)
          } else {
            this.formattedGroupLimit = ''
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.parentCompanyList = []
      this.formId = ''
      this.name = ''
      this.formattedGroupLimit = '' // 重置格式化值
    },
    async handleSaveBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        try {
          if (this.formId) {
            this.form.groupLimit = this.$utils.resetAmount(this.form.groupLimit)
            await update(this.formId, { ...this.form })
          } else {
            this.form.groupLimit = this.$utils.resetAmount(this.form.groupLimit)
            await add({ ...this.form })
          }
          this.$message.success('success')
          this.initTable()
          this.visible = false
        } catch (err) {
          console.log(err)
        }
      }
    },
    async updateAndAdd(params) {
      try {
        await add(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
  },
}
</script>
